;(function () {
  'use strict'

  angular
    .module('contrast.app-environment')
    .controller('appEnvironmentCtrl', appEnvironmentCtrl)

  function appEnvironmentCtrl(
    $routeSegment,
    $q,
    $uibModal,
    $routeParams,
    $location,
    $translate,
    permissions,
    ChartService,
    ErrorService,
    UserService,
    LoadFilterRouteService,
    ApplicationScoresFactory,
    ApplicationFactory,
    FeaturesService,
    LanguagesService,
    LoadFilterService,
    SERVER_ENVIRONMENTS,
    SERVER_ENVIRONMENT_LIST,
    VULNERABILITY_REPORT_RANGES_DASHBOARD,
    reportFilterService,
    VULNERABILITY_REPORT_TYPE,
    tutorialModalService,
    orgTraceApiConfig,
    ApplicationTrendsFactory,
    SUBFILTERS,
    AGENT_FEATURE,
    SERVER_ENVIRONMENT,
    APP_ENVIRONMENT_TYPE,
    TIME_SERIES_SELECT,
    QUICK_FILTERS
  ) {
    'ngInject'

    var translGlobal = {
      title_attacks: $translate.instant('title_attacks'),
      title_vulnerabilities: $translate.instant('title_vulnerabilities'),
      title_applicationEnvironment_viewVulnerabilities: $translate.instant(
        'title_applicationEnvironment_viewVulnerabilities'
      ),
      title_applicationEnvironment_viewAttacks: $translate.instant(
        'title_applicationEnvironment_viewAttacks'
      )
    }

    var vm = this,
      appId = $routeSegment.$routeParams.appId

    angular.extend(vm, {
      activated: false,
      app: {},
      isAssessLanguageSupported: false,
      isProtectLanguageSupported: false,
      isProxySupported: false,
      orgUuid: $routeSegment.$routeParams.orgUuid,
      appId: appId,
      thermometer: {
        types: [],
        allTypes: [
          {
            value: translGlobal.title_applicationEnvironment_viewAttacks,
            label: translGlobal.title_attacks,
            title: APP_ENVIRONMENT_TYPE.ATTACKS
          },
          {
            value:
              translGlobal.title_applicationEnvironment_viewVulnerabilities,
            label: translGlobal.title_vulnerabilities,
            title: APP_ENVIRONMENT_TYPE.VULNERABILITIES
          }
        ],
        type: null,
        breakdowns: [],
        breakdown: null,

        attacks: {},
        vulnerabilities: {}
      },
      vulnTrendRanges: VULNERABILITY_REPORT_RANGES_DASHBOARD,
      vulnTrendRangeSelected: VULNERABILITY_REPORT_RANGES_DASHBOARD[0],
      vulnTrendChartData: {
        loaded: false,
        open: [],
        closed: []
      },
      timeseries: {
        attacks: {},
        scores: {},
        times: undefined,
        time: undefined
      }
    })

    angular.extend(vm, {
      activate: activate,
      serverCountChange: serverCountChange,
      isRASPEnabled: isRASPEnabled,
      typeSelected: typeSelected,
      timeSelected: timeSelected,
      breakdownSelected: breakdownSelected,
      isThermometerTitleAttacks: isThermometerTitleAttacks,
      isThermometerTitleVulnerabilities: isThermometerTitleVulnerabilities,
      hasThermometerType: hasThermometerType,
      isDev: isDev,
      isQA: isQA,
      isProd: isProd,
      hasAssessServers: hasAssessServers,
      hasProtectServers: hasProtectServers,
      allServersHaveProtectConflicts: allServersHaveProtectConflicts,
      hasServers: hasServers,
      showAssess: showAssess,
      showDefense: showDefense,
      showAddServers: showAddServers,
      onThermometerClick: onThermometerClick,
      onAttackCountClick,
      goToOpenVulns: goToOpenVulns,
      getEnvName: getEnvName,
      changeRange: _getGraphData,
      isEmptyEnv: isEmptyEnv,
      hasProtectOrAssess: hasProtectOrAssess,
      showAssessRecommendation: showAssessRecommendation,
      isProdOrHasServers: isProdOrHasServers,
      hasProdServersWithoutProtectOrAssess:
        hasProdServersWithoutProtectOrAssess,
      hasOnlyProtectServers: hasOnlyProtectServers,
      hasOnlyAssessServers: hasOnlyAssessServers,
      showEnvSummary: showEnvSummary
    })

    function activate() {
      //For freemium orgs, only the 7 days option (index 0) will be displayed
      if (UserService.isFreemiumOrganization()) {
        vm.timeseries.times = [TIME_SERIES_SELECT[0]]
        vm.timeseries.time = TIME_SERIES_SELECT[0]
      } else {
        //For enterprise orgs, the default option will be the 7 days option (index 0)
        vm.timeseries.times = TIME_SERIES_SELECT
        vm.timeseries.time = TIME_SERIES_SELECT[0]
      }

      _getApplication()
    }

    function _getApplication() {
      return ApplicationFactory.getApplication(appId)
        .then(function (response) {
          vm.app = response.data.application
          vm.isAssessLanguageSupported = FeaturesService.isAgentFeatureEnabled(
            AGENT_FEATURE.ASSESS,
            vm.app.language,
            true
          )
          vm.isProtectLanguageSupported = FeaturesService.isAgentFeatureEnabled(
            AGENT_FEATURE.PROTECTION,
            vm.app.language,
            true
          )
          vm.isProxySupported = LanguagesService.isProxy(vm.app.language)
        })
        .then(_initializeThermometer)
        .then(_getGraphData)
        .then(function () {
          vm.activated = true
        })
    }

    function _getGraphData() {
      vm.vulnTrendChartData.loaded = false

      var form = reportFilterService.createRequest({
        type: vm.vulnTrendRangeSelected.group,
        serverEnvironments: vm.data.environment,
        servers: _transformServersArray(vm.data.servers),
        applications: [{ value: appId }],
        rules: []
      })

      var promise
      if (
        vm.vulnTrendRangeSelected.group.toLowerCase() ==
        VULNERABILITY_REPORT_TYPE.NEW.toLowerCase()
      ) {
        vm.vulnTrendChartType = VULNERABILITY_REPORT_TYPE.NEW
        promise = orgTraceApiConfig.getNewTrendData(
          vm.vulnTrendRangeSelected.keycode,
          form
        )
      } else {
        vm.vulnTrendChartType = VULNERABILITY_REPORT_TYPE.TOTAL
        promise = orgTraceApiConfig.getTotalTrendData(
          vm.vulnTrendRangeSelected.keycode,
          form
        )
      }

      return promise
        .then(function (response) {
          vm.vulnTrendChartData.loaded = true
          vm.vulnTrendChartData.closed = response.data.closed
          vm.vulnTrendChartData.open = response.data.open
        })
        .catch(ErrorService.processError)
    }

    function _transformServersArray(a) {
      if (angular.isArray(a)) {
        return a.map(function (o) {
          return { value: o.server_id }
        })
      }
      return []
    }

    function isRASPEnabled() {
      return permissions.isRASPEnabled()
    }

    function typeSelected(item) {
      _populateThermometerBreakdowns(item.title)
      _updateThermometerData()
      _updateTimeSeriesData()
      _getGraphData()
    }

    function timeSelected() {
      _updateTimeSeriesData()
    }

    function breakdownSelected() {
      _updateThermometerData()
    }

    function isThermometerTitleAttacks() {
      return vm.thermometer.type.title === APP_ENVIRONMENT_TYPE.ATTACKS
    }

    function isThermometerTitleVulnerabilities() {
      return vm.thermometer.type.title === APP_ENVIRONMENT_TYPE.VULNERABILITIES
    }

    function hasThermometerType() {
      return angular.isDefined(vm.thermometer.type)
    }

    function isDev() {
      return vm.data.environment == SERVER_ENVIRONMENT.DEVELOPMENT.value
    }

    function isQA() {
      return vm.data.environment == SERVER_ENVIRONMENT.QA.value
    }

    function isProd() {
      return vm.data.environment == SERVER_ENVIRONMENT.PRODUCTION.value
    }

    function hasAssessServers() {
      return vm.data.servers_assessment > 0
    }

    function hasProtectServers() {
      return vm.data.servers_protection > 0
    }

    function allServersHaveProtectConflicts() {
      if (!vm.data.servers || vm.data.servers.length === 0) {
        return false
      }

      return vm.data.servers.every(function (server) {
        return server.has_instrumentation_conflict
      })
    }

    function hasServers() {
      return vm.data.total_servers > 0
    }

    function showAssess() {
      LoadFilterRouteService.goToServersFilteredByApp($routeParams.appId)
      tutorialModalService.openAssess()
    }

    function showDefense() {
      LoadFilterRouteService.goToServersFilteredByApp($routeParams.appId)
      $uibModal.open({
        templateUrl: 'components-org/tutorial/modal-protection-start.html',
        controller: 'TutorialModalCtrl',
        size: 'md-sm',
        openedClass: 'modal-open tutorial-modal'
      })
    }

    function showAddServers() {
      $uibModal.open({
        templateUrl: 'views/applications/modal_add_servers.html',
        controller: 'TutorialModalCtrl',
        size: 'md-sm',
        openedClass: 'modal-open tutorial-modal'
      })
      LoadFilterRouteService.goToServersFilteredByApp($routeParams.appId)
    }

    function onAttackCountClick() {
      LoadFilterService.setAttackEnvironment(vm.data.environment)
      $location.path(
        UserService.buildUrl('/applications/' + appId + '/attacks')
      )
    }

    function onThermometerClick(record) {
      if (record.link) {
        var env = vm.data.environment
        if (record.type == 'vuln') {
          var filters = {}

          switch (record.breakdown) {
            case 'Severity':
              filters[SUBFILTERS.VULNS.ENUM.SEVERITY] = [
                record.keycode.toUpperCase()
              ]
              filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
                'Reported',
                'Suspicious',
                'Confirmed'
              ]
              filters[SUBFILTERS.VULNS.ENUM.SERVER_ENVIRONMENT] = [
                env.toString()
              ]
              LoadFilterRouteService.goToApplicationVulnerabilities(
                filters,
                appId
              )
              break

            case 'Status':
              filters[SUBFILTERS.VULNS.ENUM.STATUS] = [record.keycode]
              filters[SUBFILTERS.VULNS.ENUM.SERVER_ENVIRONMENT] = [
                env.toString()
              ]
              LoadFilterRouteService.goToApplicationVulnerabilities(
                filters,
                appId
              )
              break

            case 'Type':
              filters[SUBFILTERS.VULNS.ENUM.VULNTYPE] = Array.isArray(
                record.keycodes
              )
                ? record.keycodes
                : [record.keycode]

              filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
                'Reported',
                'Suspicious',
                'Confirmed'
              ]
              filters[SUBFILTERS.VULNS.ENUM.SERVER_ENVIRONMENT] = [
                env.toString()
              ]
              LoadFilterRouteService.goToApplicationVulnerabilities(
                filters,
                appId
              )
              break

            default:
              break
          }
        } else if (record.type == 'attack') {
          if (!vm.isFreemium) {
            if (record.breakdown === 'Status') {
              LoadFilterService.setAttackStatus(record.name.toUpperCase())
            } else {
              LoadFilterService.setAttackQuickFilter(
                QUICK_FILTERS.ATTACK_EVENTS[record.name.toUpperCase()].KEY
              )
            }
            LoadFilterService.setAttackEnvironment(env)
            $location.path(
              UserService.buildUrl('/applications/' + appId + '/attacks')
            )
          } else {
            $location.path(UserService.buildUrl('/attacks/attacks'))
          }
        }
      }
    }

    function goToOpenVulns() {
      var env = vm.data.environment,
        filters = {}

      for (var i = 0; i < SERVER_ENVIRONMENT_LIST.length; i++) {
        if (SERVER_ENVIRONMENT_LIST[i].name == vm.data.environment) {
          env = SERVER_ENVIRONMENT_LIST[i].value
        }
      }

      filters[SUBFILTERS.VULNS.ENUM.STATUS] = [
        'Reported',
        'Suspicious',
        'Confirmed'
      ]
      filters[SUBFILTERS.VULNS.ENUM.SERVER_ENVIRONMENT] = [env.toString()]
      LoadFilterRouteService.goToApplicationVulnerabilities(filters, appId)
    }

    function getEnvName() {
      var key = vm.data.environment
      if (angular.isString(key) && SERVER_ENVIRONMENT[key]) {
        return SERVER_ENVIRONMENT[key].name
      }
      return ''
    }

    function serverCountChange(newVal) {
      if (angular.isNumber(newVal)) {
        if (newVal > 0 && vm.thermometer.types.length < 1) {
          _initializeThermometer()
        } else {
          _populateThermometerTypes()
          if (vm.thermometer.type) {
            if (
              vm.thermometer.type.title == APP_ENVIRONMENT_TYPE.ATTACKS &&
              vm.data.servers_protection == 0
            ) {
              _setThermometerType(APP_ENVIRONMENT_TYPE.VULNERABILITIES)
              _updateThermometerData()
              _updateTimeSeriesData()
              _getGraphData()
            } else if (
              vm.thermometer.type.title ==
                APP_ENVIRONMENT_TYPE.VULNERABILITIES &&
              vm.data.servers_assessment == 0 &&
              permissions.isRASPEnabled()
            ) {
              _setThermometerType(APP_ENVIRONMENT_TYPE.ATTACKS)
              _updateThermometerData()
              _updateTimeSeriesData()
              _getGraphData()
            }
          } else {
            if (vm.data.servers_assessment > 0) {
              _setThermometerType(APP_ENVIRONMENT_TYPE.VULNERABILITIES)
            } else if (
              vm.data.servers_protection > 0 &&
              permissions.isRASPEnabled()
            ) {
              _setThermometerType(APP_ENVIRONMENT_TYPE.ATTACKS)
            }

            _updateThermometerData()
            _updateTimeSeriesData()
            _getGraphData()
          }
        }
      }
    }

    function _initializeThermometer() {
      _populateThermometerTypes()

      var isProtectionEnabled =
        vm.data.servers_protection > 0 && permissions.isRASPEnabled()
      if (
        vm.data.environment == SERVER_ENVIRONMENTS.PROD.id &&
        isProtectionEnabled
      ) {
        _setThermometerType(APP_ENVIRONMENT_TYPE.ATTACKS)
      } else if (
        vm.data.servers_assessment > 0 &&
        vm.isAssessLanguageSupported
      ) {
        _setThermometerType(APP_ENVIRONMENT_TYPE.VULNERABILITIES)
      } else if (isProtectionEnabled) {
        _setThermometerType(APP_ENVIRONMENT_TYPE.ATTACKS)
      }

      _updateThermometerData()
      _updateTimeSeriesData()
      _getGraphData()
    }

    function _populateThermometerTypes() {
      var temp = []
      if (vm.data.servers_protection > 0 && permissions.isRASPEnabled()) {
        temp.push(vm.thermometer.allTypes[0])
      }
      if (vm.data.servers_assessment > 0 && vm.isAssessLanguageSupported) {
        temp.push(vm.thermometer.allTypes[1])
      }

      vm.thermometer.types = temp
    }

    function _setThermometerType(type) {
      if (type == APP_ENVIRONMENT_TYPE.VULNERABILITIES) {
        vm.thermometer.type = vm.thermometer.allTypes[1]
      } else if (type == APP_ENVIRONMENT_TYPE.ATTACKS) {
        vm.thermometer.type = vm.thermometer.allTypes[0]
      }
      _populateThermometerBreakdowns(type)
    }

    function _populateThermometerBreakdowns(type) {
      if (type == APP_ENVIRONMENT_TYPE.VULNERABILITIES) {
        vm.thermometer.breakdowns = ChartService.getTraceBreakdownTypes()
        vm.thermometer.breakdown = vm.thermometer.breakdowns[0]
      } else if (type == APP_ENVIRONMENT_TYPE.ATTACKS) {
        vm.thermometer.breakdowns = ChartService.getAttackBreakdownTypes()
        vm.thermometer.breakdown = vm.thermometer.breakdowns[0]
      }
    }

    function _updateThermometerData() {
      if (vm.thermometer.type) {
        var promise = null,
          envValue = vm.data.environment,
          type = vm.thermometer.type.title,
          breakdown = vm.thermometer.breakdown
        if (type == APP_ENVIRONMENT_TYPE.ATTACKS) {
          if (breakdown === 'Status') {
            promise = ApplicationScoresFactory.getAttackBreakdownByStatus(
              appId,
              envValue
            )
          } else if (breakdown === 'Type') {
            promise = ApplicationScoresFactory.getAttackBreakdownByType(
              appId,
              envValue
            )
          }
        } else if (type == APP_ENVIRONMENT_TYPE.VULNERABILITIES) {
          if (breakdown === 'Severity') {
            promise = ApplicationScoresFactory.getTraceBreakdownBySeverity(
              appId,
              envValue
            )
          } else if (breakdown === 'Status') {
            promise = ApplicationScoresFactory.getTraceBreakdownByStatus(
              appId,
              envValue
            )
          } else if (breakdown === 'Type') {
            promise = ApplicationScoresFactory.getTraceBreakdownByType(
              appId,
              envValue
            )
          }
        }

        if (promise) {
          promise
            .then(function (response) {
              var data = response.data,
                thermometerData = {}

              if (type == APP_ENVIRONMENT_TYPE.ATTACKS) {
                thermometerData = ChartService.buildAttackThermometerData(
                  breakdown,
                  data
                )
                vm.thermometer.attacks = thermometerData
              } else if (type == APP_ENVIRONMENT_TYPE.VULNERABILITIES) {
                thermometerData = ChartService.buildTraceThermometerData(
                  breakdown,
                  data
                )
                vm.thermometer.vulnerabilities = thermometerData
              }
            })
            .catch(ErrorService.processError)
        }
      }
    }

    function _updateTimeSeriesData() {
      if (vm.thermometer.type) {
        var promise = null,
          envValue = vm.data.environment,
          type = vm.thermometer.type.title,
          interval = _getTimeSeriesInterval()

        if (type == APP_ENVIRONMENT_TYPE.ATTACKS) {
          promise = ApplicationTrendsFactory.getAttackTrendByInterval(
            appId,
            true,
            interval,
            envValue
          )
        } else if (type == APP_ENVIRONMENT_TYPE.VULNERABILITIES) {
          promise = _updateTimeSeriesDataVulnerabilitiesData(interval, envValue)
        }

        if (promise) {
          promise
            .then(function (response) {
              if (type == APP_ENVIRONMENT_TYPE.ATTACKS) {
                vm.timeseries.scores = ChartService.buildAttackTrendData(
                  response,
                  vm.timeseries.time.text
                )
              } else if (type == APP_ENVIRONMENT_TYPE.VULNERABILITIES) {
                vm.timeseries.scores =
                  ChartService.buildScoreTrendData(response)
              }
            })
            .catch(ErrorService.processError)
        }
      }
    }

    function _updateTimeSeriesDataVulnerabilitiesData(interval, envValue) {
      var promises = []

      promises.push(
        ApplicationTrendsFactory.getHistoryTrendByInterval(
          appId,
          false,
          interval,
          envValue
        ).then(function (response) {
          return { history: response.data }
        })
      )

      if (vm.data.servers_protection > 0 && permissions.isRASPEnabled()) {
        promises.push(
          ApplicationTrendsFactory.getDefenseHistoryTrendByInterval(
            appId,
            false,
            interval,
            envValue
          ).then(function (response) {
            return { defense: response.data }
          })
        )
      }

      return $q.all(promises)
    }

    function _getTimeSeriesInterval() {
      return ChartService.getIntervals().find(function (value) {
        return value.description == vm.timeseries.time.text
      }).value
    }

    function isNotProdEnv() {
      return isDev() || isQA()
    }

    function hasProtectServersAndRASP() {
      return hasProtectServers() && isRASPEnabled()
    }

    function hasProtectOrAssess() {
      return hasProtectServersAndRASP() || hasAssessServers()
    }

    function isEmptyEnv() {
      return isNotProdEnv() && !hasServers() && !hasProtectOrAssess()
    }

    function hasProdServersWithoutProtectOrAssess() {
      return isProd() && hasServers() && !hasProtectOrAssess()
    }

    function isProdOrHasServers() {
      return isProd() || hasServers()
    }

    function hasSomeServerWithoutConflict() {
      return hasServers() && !allServersHaveProtectConflicts()
    }

    function showAssessRecommendation() {
      return (
        isNotProdEnv() &&
        hasSomeServerWithoutConflict() &&
        !hasProtectOrAssess()
      )
    }

    function hasOnlyProtectServers() {
      return hasProtectServers() && !hasAssessServers()
    }

    function hasOnlyAssessServers() {
      return hasAssessServers() && !hasProtectServers()
    }

    function hasProtectOrAllServersWithConflict() {
      return (
        isRASPEnabled() &&
        (hasProtectServers() || allServersHaveProtectConflicts())
      )
    }

    function showEnvSummary() {
      const hasProtectOrAssess =
        hasProtectOrAllServersWithConflict() || hasAssessServers()

      return hasProtectOrAssess && isProdOrHasServers()
    }
  }
})()
